export const useDrilldownGroup = (drilldownState, query, subject_type = '') => {
  const drilldownGroupMappings = {
    // Interview metrics
    'Completed interviews by duration': {
      group_by_1: { id: 'duration' },
    },

    // Offer metrics
    'Offers by department': {
      group_by_1: { id: 'department' },
    },
    'Offers by location': {
      group_by_1: { id: 'appl_location' },
    },

    // Hire metrics
    'Hires by department': {
      group_by_1: { id: 'department' },
    },
    'Hire by source (on application)': {
      group_by_1: { id: 'appl_contact_source' },
    },

    // Rejection metrics
    'We rejected them': {
      group_by_1: { id: 'rejection_type' },
      group_by_2: { id: 'rejection_reason' },
    },
    'They rejected us': {
      group_by_1: { id: 'rejection_type' },
      group_by_2: { id: 'rejection_reason' },
    },
    Others: {
      group_by_1: { id: 'rejection_type' },
      group_by_2: { id: 'rejection_reason' },
    },
    'Rejection by stage': {
      group_by_1: { id: 'rejected_milestone' },
    },
    'Rejections by source (on application)': {
      group_by_1: { id: 'appl_contact_source' },
    },
    'Rejections by source': {
      group_by_1: { id: 'appl_contact_source' },
    },

    // Job metrics
    'Job open trend': {
      group_by_2: { id: 'job_type' },
    },
    'Jobs opened by location': {
      group_by_1: { id: 'job_location' },
    },
    'Jobs opened by department': {
      group_by_1: { id: 'department' },
    },

    //contact metrics
    'New contact trend by source': {
      group_by_2: { id: 'contact_source' },
    },
    'New contact trend by source (on contact)': {
      group_by_2: { id: 'contact_source' },
    },

    //requisition metrics
    'Requisitions by department': {
      group_by_1: { id: 'department' },
    },
    'Requisitions by requisition type': {
      group_by_1: { id: 'requisition_type' },
    },
    'Percentage of requisitions filled by department': {
      group_by_1: { id: 'department' },
    },
  };

  const getDrilldownGroup = () => {
    const { drilldownHeading, type, isParentRow, key } =
      drilldownState?.config || {};

    const mappedGroup = drilldownGroupMappings[drilldownHeading];

    if (mappedGroup) {
      return mappedGroup;
    }

    if (isParentRow && key !== 'tableTotal') {
      return { group_by_1: { id: query?.group_by_1?.id } };
    }

    if (type === 'table' && key !== 'tableTotal') {
      return {
        group_by_1: query?.group_by_1,
        group_by_2: query?.group_by_2,
      };
    }

    return null;
  };

  return { getDrilldownGroup };
};
